<style lang="less" scoped>
.ai-knowledge-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #f5f7fa;
}
.ai-knowledge-library {
  flex: 1;
  min-height: 0;
}
</style>

<template>
  <div class="ai-knowledge-page full-container">
    <KnowledgeLibrary
      class="ai-knowledge-library"
      :library-view-mode.sync="libraryViewMode"
    />
  </div>
</template>

<script>
import KnowledgeLibrary from '@/pages/core/knowledge/library.vue';

export default {
  name: 'AiMaterials',
  components: { KnowledgeLibrary },
  data() {
    return {
      libraryViewMode: 'all',
    };
  },
};
</script>
